import React from "react";
import styles from "./CancelReservationModal.module.css";
import { ReactComponent as CancelIcon } from "../../assets/icons/cancel-icon.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/Close.svg";

interface CancelReservationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CancelReservationModal: React.FC<CancelReservationModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* دکمه بستن مودال */}
        <button className={styles.closeButton} onClick={onClose}>
          <CloseIcon className={styles.closeIcon} />
        </button>

        {/* عنوان بالا و راست */}
        <h2 className={styles.modalTitle}>لغو رزرو سرویس</h2>

        {/* آیکون اصلی */}
        <div className={styles.iconContainer}>
          <CancelIcon className={styles.iconImage} />
        </div>

        {/* توضیحات */}
        <p className={styles.modalText}>
          متأسفانه سرویس انتخاب شده به علت عدم پرداخت از حالت رزرو برای شما خارج شده است تا برای سایر کاربران قابل رزرو باشد.
        </p>

        {/* دکمه تایید */}
        <button className={styles.confirmButton} onClick={onClose}>تایید</button>
      </div>
    </div>
  );
};

export default CancelReservationModal;
